// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

html[lang='fa'] {
    direction: rtl !important;
    --main-font: 'Vazirmatn', sans-serif !important;
}

html[lang='en'] {
    direction: ltr !important;
    --main-font: 'Gothic' !important;
}

:root {
    --bg-color: #191a17;
}

html[data-theme='day'] {
    --bg-color: #E5E5E5;
}

html[data-theme='night'] {
    --bg-color: #191a17;
}

body {
  background-color: var(--bg-color);
  color: var(--text-color);
  transition: background-color 0.3s ease, color 0.3s ease;
}

body, 
p, 
h1, h2, h3, h4, h5, h6, 
span, 
a, 
button, 
input, 
textarea, 
select {
    font-family: var(--main-font) !important;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;IACI,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;EACxB,uDAAuD;AACzD;;AAEA;;;;;;;;;IASI,wCAAwC;AAC5C","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\nhtml[lang='fa'] {\n    direction: rtl !important;\n    --main-font: 'Vazirmatn', sans-serif !important;\n}\n\nhtml[lang='en'] {\n    direction: ltr !important;\n    --main-font: 'Gothic' !important;\n}\n\n:root {\n    --bg-color: #191a17;\n}\n\nhtml[data-theme='day'] {\n    --bg-color: #E5E5E5;\n}\n\nhtml[data-theme='night'] {\n    --bg-color: #191a17;\n}\n\nbody {\n  background-color: var(--bg-color);\n  color: var(--text-color);\n  transition: background-color 0.3s ease, color 0.3s ease;\n}\n\nbody, \np, \nh1, h2, h3, h4, h5, h6, \nspan, \na, \nbutton, \ninput, \ntextarea, \nselect {\n    font-family: var(--main-font) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
